import { z } from 'zod';

export const businessNameSchema = z
  .string()
  .min(1, 'Required field')
  .min(2, 'Name must be at least 2 characters')
  .max(255, 'Name must not exceed 255 characters')
  .regex(/^[\dA-Za-z].*/, 'Name must start with letter')
  .regex(/^[\d\s'(),.A-Za-z\-]*$/, "Name can only contain letters, numbers and -'.,()");

export type BusinessName = z.infer<typeof businessNameSchema>;
